import { useEffect, useState } from 'react';

export const useWhatsAppWidget = () => {
  const [open, setOpen] = useState(false);
  const [showTip, setShowTip] = useState(false);
  useEffect(() => {
    const reveal = window.setTimeout(() => setShowTip(true), 6000);
    const hide = window.setTimeout(() => setShowTip(false), 12000);
    return () => { window.clearTimeout(reveal); window.clearTimeout(hide); };
  }, []);
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (event) => { if (event.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);
  return { open, showTip: showTip && !open, close: () => setOpen(false), toggle: () => setOpen((current) => !current) };
};